export const getIsTempProject = (projectName?: string) => projectName?.startsWith("temp");
